import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import base from '@/_api/base';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '../query-keys';

export function useFaqsQuery(festivalId) {
  return useGetQuery(
    () => `/admin/faqs/${festivalId}`,
    {},
    queryKeys.faqs(festivalId),
    { enabled: festivalId != null && festivalId !== '' },
  );
}

export function useSaveFaqMutation(festivalId) {
  const queryClient = useQueryClient();
  return useApiMutation(
    (faq) => `/admin/faq/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.faqs(festivalId) });
        NotificationManager.success('FAQ saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Failed to save FAQ', 'Error', 3000);
      },
    },
  );
}

export function useRemoveFaqMutation(festivalId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (faqId) => base.delete(`/admin/faq/${faqId}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.faqs(festivalId) });
      NotificationManager.success('FAQ removed', '', 3000);
    },
    onError: () => {
      NotificationManager.error('FAQ could not be removed', '', 3000);
    },
  });
}
